exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal[data-v-701ac82d] {\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n}\n.backdrop[data-v-701ac82d] {\n  background: rgba(0, 0, 0, 0.6);\n}\n", ""]);

// exports
